<template>
  <!-- dialog add docs -->
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'550px'"
    :appendToBody="true"
    :modalAppendToBody="true"
    :classDialog="'dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <h3 class="dialogTitle">
        {{ id ? "SỬA KÍ HIỆU VĂN BẢN" : "THÊM MỚI KÍ HIỆU VĂN BẢN" }}
      </h3>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="120px"
        inline-message
      >
        <el-form-item label="Loại văn bản: " prop="docTypeId">
          <el-select
            class="style-fullWidth input-border__bottom input-border__radius__0"
            v-model="form.docTypeId"
            size="medium"
            filterable
            placeholder="-"
            clearable
          >
            <el-option
              v-for="item in catDocTypes"
              :key="item.id"
              :label="item.categoryName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Số ký hiệu: " prop="prefix">
          <el-input
            v-model="form.prefix"
            size="medium"
            class="input-detail__editable style-fullWidth input-border__bottom input-border__radius__0"
            maxlength="100"
          />
        </el-form-item>
      </el-form>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action margin-top-10">
        <el-button
          type="success"
          size="mini"
          class="addDocs color__white bg__blue btn-none__border"
          @click="submit"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Xác nhận
        </el-button>
        <el-button
          type="info"
          size="mini"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >
          <i class="fas fa-ban"></i>
          &nbsp;Hủy
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>

<script>
import categoryViewService from "../../services/categoryViewService";
import bookDocTypeService from "../../services/bookDocTypeService";
import constants from "../../constants";
import handleRequestErrorMixin from "../handleRequestErrorMixin";

export default {
  name: "create-book-doc-type-dialog",
  mixins: [handleRequestErrorMixin],
  props: ["isOpen", "bookId", "id", "docTypeSelected"],
  // filters: {dateFormatter},
  components: {
    dialogTemplate: () => import("../common/custom-dialog.vue"),
  },
  data() {
    return {
      catDocTypes: [],
      form: {
        // id: null,
        docTypeId: null,
        docTypeName: null,
        prefix: null,
      },
      rules: {
        docTypeId: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "blur",
          },
        ],
        prefix: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.loadCatDocTypes();
    this.id && this.loadBookDocType();
  },
  watch: {},

  methods: {
    loadBookDocType() {
      return bookDocTypeService
        .findById(this.id)
        .then((response) => {
          this.form.docTypeId = response.data.docTypeId;
          this.form.docTypeName = response.data.docTypeName;
          this.form.prefix = response.data.prefix;
        })
        .catch((error) => this.commonHandleRequestError(error));
    },

    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        let submitForm = {
          bookId: this.bookId,
          docTypeId: this.form.docTypeId,
          docTypeName: this.form.docTypeName,
          prefix: this.form.prefix,
        };

        if (this.id) {
          // in case update
          bookDocTypeService
            .update(this.id, submitForm)
            .then((response) => {
              this.$message({
                message: "Cập nhật kí hiệu văn bản thành công",
                type: "success",
              });
              this.$emit("success", { userDeptRole: response.data });
              this.loadBookDocType();
            })
            .catch((error) => this.commonHandleRequestError(error));
        } else {
          // in case insert
          bookDocTypeService
            .add(submitForm)
            .then((response) => {
              this.$message({
                message: "Cập nhật kí hiệu văn bản thành công",
                type: "success",
              });
              this.$emit("success", { userDeptRole: response.data });
            })
            .catch((error) => this.commonHandleRequestError(error));
        }
      });
    },

    loadCatDocTypes() {
      let selected = this.docTypeSelected || [];
      categoryViewService
        .findAll(
          { groupCode: constants.CATEGORY_GROUP_CODE.DOC_TYPE },
          { page: 0, size: 1000 }
        )
        .then(
          (response) =>
            (this.catDocTypes = response.data.filter(
              (item) =>
                item.status !== "deactive" &&
                !selected.find((x) => x.docTypeId === item.id)
            ))
        );
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/book/createBookDocType.vue